require('./view.component.scss');

class ViewController {
  constructor(
    $scope,
    $element,
    CurrentFilterService,
    CurrentModelService,
    CurrentFilterDataService,
    PermissionService,
    RouterService,
    LayoutService,
  ) {
    this.$scope = $scope;
    this.$element = $element;
    this.CurrentFilterService = CurrentFilterService;
    this.CurrentModelService = CurrentModelService;
    this.CurrentFilterDataService = CurrentFilterDataService;
    this.permission = PermissionService;
    this.router = RouterService;
    this.layout = LayoutService;
  }

  get filter() {
    return this.CurrentFilterService.filter;
  }

  get filterBar() {
    return this.CurrentFilterService.filterBar;
  }

  get model() {
    return this.CurrentModelService.model;
  }

  get filterData() {
    return this.CurrentFilterDataService.filterData;
  }

  get frameUrl() {
    return this.CurrentFilterService.frameUrl;
  }

  set frameUrl(value) {
    this.CurrentFilterService.frameUrl = value;
  }

  get isCatalog() {
    return this.CurrentFilterService.panel !== 'constructor' && this.filter.isCatalog;
  }

  showMenu() {
    //return this.CurrentFilterService.panel !== 'catalog' && !this.layout.hideMenu;
    return true;
  }

  getHeightPx() {
    if (this.layout.isPrint && (this.filter.isChart() || this.filter.isChartArea() ||
        this.filter.isTree() || this.filter.isGraph)) {
      return this.$element.width() * 0.618;
    }
  }

  getHeight() {
    let height = this.getHeightPx();
    if (!height) {
      return 'auto';
    }
    return (height) + 'px';
  }
}

export const ViewComponent = {
  template  : require('./view.component.html'),
  bindings  : {},
  controller: ViewController,
};



// WEBPACK FOOTER //
// ./src/view/view.component.js